export const accessLevels = {
  modifyList: ['Admin'],
  modifyMembers: ['Write', 'Push', 'Admin'],
  push: ['Push', 'Admin'],
};
